export default __webpack_public_path__ + "static/media/cegah (3).cc676a29.png";